import { ISectionProps } from "../../Orchestrator/Types/Index";
import React from "react";

const Section: React.FC<ISectionProps> = ({
  type,
  height,
  width,
  color,
  children,
}) => {
  const style: React.CSSProperties = {};
  if (height) style.height = `${height}px`;
  if (width) style.width = `${width}px`;
  if (color) style.backgroundColor = color;

  return (
    <section className={`${type}`} style={style} data-testid="section">
      {children}
    </section>
  );
};

export default Section;
